import { Flex, Link, Image, Text } from '@chakra-ui/react';
import { Link as ReactRouterLink } from 'react-router-dom';
import { UserProfile } from '../../service/social';
import config from '../../config';
import { getUserName } from '../../service/lobby';

interface FollowerListItemProps {
    user: UserProfile;
}

export const FollowerListItem: React.FC<FollowerListItemProps> = ({ user }) => {
    return (
        <Flex className={'follower-list-item'}>
            <Link as={ReactRouterLink} to={`/user/${user.id}`}>
                <Image
                    className={'follower-avatar-image'}
                    src={
                        user.avatar_object_url ||
                        user.twitch_profile?.profile_image_url ||
                        config.avatarPlaceholderURL
                    }
                />
            </Link>
            <Flex className="follower-info">
                <Text>{getUserName(user)}</Text>
            </Flex>
        </Flex>
    );
};
